import "./CanvasArea.scss"
import Canvas from "@components/Canvas"
function CanvasArea() {
  return (
    <div className="canvasarea">
      <Canvas />
    </div>
  )
}

export default CanvasArea
